var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/Text.style.ts
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import * as fonts from "@teamsparta/stack-font";
import { getVar } from "@teamsparta/stack-utils";
var designSystemFontMap = fonts;
var TextBase = styled.span`
  color: ${getVar("--text-color")};
  text-align: ${getVar("--text-align")};

  ${({ fonts: fonts2 }) => {
  return fonts2 == null ? void 0 : fonts2.map(({ breakpoint, font }) => {
    return font && css`
          @media screen and (min-width: ${breakpoint}px) {
            ${designSystemFontMap[font]}
            color: ${getVar("--text-color")};
          }
        `;
  });
}};
`;

export {
  __spreadValues,
  __spreadProps,
  __objRest,
  TextBase
};
